import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import sk from "./locales/sk.json";

const LANG_STORAGE_KEY = "eulchen-lang";

function readStoredLanguage() {
  try {
    const v = localStorage.getItem(LANG_STORAGE_KEY);
    if (v === "sk" || v === "en") return v;
  } catch {
    /* ignore */
  }
  return "en";
}

function applyDocumentLang(lng) {
  if (typeof document !== "undefined") {
    document.documentElement.lang = lng === "sk" ? "sk" : "en";
  }
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    sk: { translation: sk },
  },
  lng: readStoredLanguage(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

applyDocumentLang(i18n.language);

i18n.on("languageChanged", (lng) => {
  try {
    localStorage.setItem(LANG_STORAGE_KEY, lng);
  } catch {
    /* ignore */
  }
  applyDocumentLang(lng);
});

export default i18n;
